// bliss coins reward redirect
$(document).ready(function() {

  // Remove from localStorage
  localStorage.removeItem("clickpost_edd_clicked");
  localStorage.removeItem("drop_pincode");
  // Remove from sessionStorage
  sessionStorage.removeItem("clickpost_edd_clicked");
  sessionStorage.removeItem("drop_pincode");




  let target = document.querySelector('#bliss_coins_popup');
  let checker = document.querySelector('#header_bliss_coins');
  let is_customer = target.getAttribute("data-customer");
  let close_tooltip = getCookie("close_tooltip");
  
  if(is_customer == 'true'){
    target.removeAttribute('hover-tooltip');
  } else if(is_customer == 'false' && close_tooltip == null){
    target.setAttribute('hover-tooltip','');
  }

  // Reward Page Redirect
  if(is_customer == "true" && window.location.pathname == checker.getAttribute("data-logged_out_url")){
    window.location.href = checker.getAttribute("data-logged_in_url");
  }else if(is_customer == "false" && window.location.pathname == checker.getAttribute("data-logged_in_url")){
    window.location.href = checker.getAttribute("data-logged_out_url");
  }
  $(document).on("swell:initialized", () => {
    getRewards();
  });
});
// bliss coins close Tooltip
function closeTooltip(){
  let target = document.querySelector('#bliss_coins_popup');
  target.removeAttribute('hover-tooltip');
  setCookie("close_tooltip","true",1);
}

// Whole Cart Update
document.addEventListener("cart:change", (event) => {
  setTimeout(() => {
    let cartJson = event.detail.cart;
    // sticky checkout bar Start
    (cartJson.item_count === 0)?$('.checkout-sticky').removeClass('is-visible'):$('.checkout-sticky').addClass('is-visible');
    $('.cart-mrp-price').html($('#checkout_price').attr('data-mrp'));
    $('.cart-subtotal-price').html($('#checkout_price').attr('data-total'));
    $('.coins').html($('#checkout_price').attr('data-coins'));
    // sticky checkout bar End
  }, "500");
});

// Product Page Deselect Start
$(document).ready(function() {
  document.dispatchEvent(new CustomEvent("custom:quick-buy", {
    bubbles: true,
    detail: null
  }));
});
document.addEventListener("custom:quick-buy", (event) => {
  $('.deselect~[type="radio"]').click(function(e) {
    let target = document.querySelector('#deselect-'+$(this).attr('form'));
    (target != undefined && target != null)?target.removeAttribute('checked'):'';
  });
  // Product Page Deselect Variant Wizard start
  $('.rio-options [aria-label="Size"][data-option-type="button"] [tabindex]').click(function(e) {
    let target = document.querySelector('#deselect-'+$(this).parents('.rio-options').siblings('.product-info__variant-picker').find('variant-picker').attr('form'));
    (target != undefined && target != null)?target.removeAttribute('checked'):'';
    $(this).removeClass('remove-active');
  });
  // Product Page Deselect Variant Wizard End
});
// Product Page Deselect End

// document.addEventListener("variant:change", (event) => {
//   let section_id = $(event.target).attr('id');
//   let json = JSON.parse(document.querySelector('#json-'+section_id).textContent);
//   let target = document.querySelector('#deselect-'+section_id);
//   let notify = document.querySelector('#notify-'+section_id);
//   let button = document.querySelector('[form="'+section_id+'"]>[type="submit"]');
//   let button_text = document.querySelector('[form="'+section_id+'"]>[type="submit"]>div');
//   let variant_text = document.querySelector('#notify-form-'+section_id+' [name="Variant_name"]');
//   let current_variant = event.detail.variant;

//   // Product Page Notifyme Form Variant Text
//   (variant_text != null)?variant_text.value = event.detail.variant.title:'';
  
//   // Product Page Preorder And Notify Me Start
//   // console.log(json);
//   const result_preorder = json.filter(item => item['id'] == event.detail.variant.id);
//   if(result_preorder.length > 0){
//     if(event.detail.variant.available && result_preorder[0].quantity <= 0 && result_preorder[0].inventory_policy == 'continue'){
//       button.classList.remove('hidden');
//       notify.classList.add('hidden');
//       // (result_preorder[0].date == '')?button_text.textContent = 'Preorder':button_text.textContent = 'Dispatch Starts on '+ result_preorder[0].date;
//       (result_preorder[0].date == '')?'':button_text.textContent = 'Dispatch Starts on '+ result_preorder[0].date;
//     } else if((event.detail.variant.available == false && result_preorder[0].hide_notify == '') || (event.detail.variant.available == false && result_preorder[0].hide_notify == 'false')) {
//       button.classList.add('hidden');
//       notify.classList.remove('hidden');
//     }else{
//       button.classList.remove('hidden');
//       notify.classList.add('hidden');
//     }
//   }else{
//     button.classList.remove('hidden');
//     notify.classList.add('hidden');
//   }
//   // Product Page Preorder And Notify Me End
  
//   // Product Page Deselect Button Start
//   if(target != undefined && target != null){
//     if (!target.checked && current_variant.available) {
//       if(button != undefined && button != null){
//         button.removeAttribute('disabled', '');
//         button.classList.remove('button--subdued');
//         button.classList.remove('hidden');
//         notify.classList.add('hidden');
//         button_text.textContent = 'Add to cart';
//       }
//     }

//     if (target.checked && target != null) {
//       if (button) {
//         button.setAttribute('disabled', '');
//         button.classList.add('button--subdued');
//         button.classList.remove('hidden');
//         notify.classList.add('hidden');
//       }
//     }
//   }
//   // Product Page Deselect Button End
  
//   // Product Page Badge Start
//   let prev_badge = document.querySelector('#badge_'+event.detail.previousVariant.id);
//   (prev_badge)?prev_badge.classList.add('hidden'):'';
//   let current_badge = document.querySelector('#badge_'+event.detail.variant.id);
//   (current_badge)?current_badge.classList.remove('hidden'):'';
//   // Product Page Badge End
// });








//start add to cart button

document.addEventListener("variant:change", (event) => {

  let section_id = $(event.target).attr('id');

  let json = JSON.parse(document.querySelector('#json-'+section_id).textContent);

  let target = document.querySelector('#deselect-'+section_id);

  let notify = document.querySelector('#notify-'+section_id);

  let button = document.querySelector('[form="'+section_id+'"]>[type="submit"]');

  let custom_button = document.querySelector('[form="'+section_id+'"]>[type="button"].custom-atc-button');

  let custom_gtb_button = document.querySelector('[form="'+section_id+'"]>[type="button"].custom-gtb-button');

  let isQuickView = section_id && section_id.indexOf('quick-buy-form-') === 0;

  let custom_sticky_quick_add = !isQuickView ? document.querySelector('product-quick-add .custom_quick_add') : null;
  let sticky_quick_add = !isQuickView ? document.querySelector('product-quick-add buy-buttons') : null;
  let sticky_gtb_button = !isQuickView ? document.querySelector('.sticky-gtb-button') : null;

  let notify_sticky = document.querySelector('#notify-sticky-'+section_id);

  let button_text = document.querySelector('[form="'+section_id+'"]>[type="submit"]>div');

  let variant_text = document.querySelector('#notify-form-'+section_id+' [name="Variant_name"]');

  let current_variant = event.detail.variant;

  (variant_text != null) ? variant_text.value = event.detail.variant.title : '';

  const result_preorder = json.filter(item => item['id'] == event.detail.variant.id);

  if (result_preorder.length > 0) {

    if (event.detail.variant.available && result_preorder[0].quantity <= 0 && result_preorder[0].inventory_policy == 'continue') {

      button.classList.remove('hidden');
      notify.classList.add('hidden');
      custom_button.classList.remove('hidden');
      if (custom_gtb_button) custom_gtb_button.classList.add('hidden');
      if (sticky_gtb_button) sticky_gtb_button.classList.add('hidden');
      (result_preorder[0].date == '') ? '' : button_text.textContent = 'Dispatch Starts on ' + result_preorder[0].date;

    } else if ((event.detail.variant.available == false && result_preorder[0].hide_notify == '') || (event.detail.variant.available == false && result_preorder[0].hide_notify == 'false')) {

      button.classList.add('hidden');
      notify.classList.remove('hidden');
      custom_button.classList.add('hidden');
      if (custom_gtb_button) custom_gtb_button.classList.add('hidden');
      if (custom_sticky_quick_add) custom_sticky_quick_add.classList.add('hidden');
      if (sticky_quick_add) sticky_quick_add.classList.add('hidden');
      if (sticky_gtb_button) sticky_gtb_button.classList.add('hidden');
      if (notify_sticky) notify_sticky.classList.remove('hidden');

    } else {

      button.classList.remove('hidden');
      notify.classList.add('hidden');
      custom_button.classList.remove('hidden');
      if (custom_gtb_button) custom_gtb_button.classList.add('hidden');
      if (sticky_gtb_button) sticky_gtb_button.classList.add('hidden');
      if (notify_sticky) notify_sticky.classList.add('hidden');

    }

  } else {

    button.classList.remove('hidden');
    notify.classList.add('hidden');
    custom_button.classList.remove('hidden');
    if (custom_gtb_button) custom_gtb_button.classList.add('hidden');
    if (sticky_gtb_button) sticky_gtb_button.classList.add('hidden');

  }

  if (target != undefined && target != null) {

    if (!target.checked && current_variant.available) {

      if (button != undefined && button != null) {
        button.removeAttribute('disabled', '');
        button.classList.remove('button--subdued');
        button.classList.remove('hidden');
        notify.classList.add('hidden');
        // button_text.textContent = 'Add to cart';
      }

      if (custom_button != undefined && custom_button != null) {
        console.log('customm');
        custom_button.classList.add('hidden');
        button.classList.remove('hidden');
      }

      if (custom_gtb_button) custom_gtb_button.classList.add('hidden');
      if (sticky_gtb_button) sticky_gtb_button.classList.add('hidden');

      let variantIdInput;
      if (isQuickView) {
        let sectionForm = document.getElementById(section_id);
        variantIdInput = sectionForm ? sectionForm.querySelector('input[name="id"]') : null;
      } else {
        variantIdInput = document.querySelector('input[name="id"]');
      }
      let variantId = parseInt(variantIdInput ? variantIdInput.value : 0);

      // if (variantId) {
      //   fetch('/cart.js')
      //     .then(res => res.json())
      //     .then(cart => {
      //       let isInCart = cart.items.some(item => item.variant_id === variantId);
      //       if (isInCart) {
      //         button.classList.add('hidden');
      //         if (custom_gtb_button) custom_gtb_button.classList.remove('hidden');
      //         if (sticky_quick_add) sticky_quick_add.classList.add('hidden');
      //         if (sticky_gtb_button) sticky_gtb_button.classList.remove('hidden');
      //       }
      //     });
      // }

      if (custom_sticky_quick_add != undefined && custom_sticky_quick_add != null) {
        console.log('customm');
        custom_sticky_quick_add.classList.add('hidden');
        if (sticky_quick_add) sticky_quick_add.classList.remove('hidden');
        if (notify_sticky) notify_sticky.classList.add('hidden');
      }
    }

    if (target.checked && target != null) {

      if (button) {
        button.setAttribute('disabled', '');
        button.classList.add('button--subdued');
        button.classList.remove('hidden');
        notify.classList.add('hidden');
      }

      if (custom_button) {
        button.classList.add('hidden');
        custom_button.classList.remove('hidden');
        notify.classList.add('hidden');
        console.log('customm');
      }

      if (custom_gtb_button) custom_gtb_button.classList.add('hidden');
      if (sticky_gtb_button) sticky_gtb_button.classList.add('hidden');

      if (custom_sticky_quick_add) {
        custom_sticky_quick_add.classList.remove('hidden');
        if (sticky_quick_add) sticky_quick_add.classList.add('hidden');
        if (notify_sticky) notify_sticky.classList.add('hidden');
        console.log('customm');
      }
    }
  }

  let prev_badge = document.querySelector('#badge_' + event.detail.previousVariant.id);
  (prev_badge) ? prev_badge.classList.add('hidden') : '';

  let current_badge = document.querySelector('#badge_' + event.detail.variant.id);
  (current_badge) ? current_badge.classList.remove('hidden') : '';

});


document.addEventListener("DOMContentLoaded", function () {

  var dummyAtcBtn = document.querySelector(".custom-atc-button");
  var goToBagBtn = document.querySelector(".custom-gtb-button");
  var defaultAtcBtn = document.querySelector('buy-buttons button[type="submit"]:not(.notify_submit)');

  var stickyDummyBtn = document.querySelector('.custom_quick_add');
  var stickyGoToBagBtn = document.querySelector('.sticky-gtb-button');
  var stickyAtcBtn = document.querySelector('.sticky-atc-btn');

  // === FIX: grab the PP notify button so showDefaultAtc() can hide it ===
  var ppNotifyBtn = document.querySelector('[id^="notify-product-form-"], [id^="notify-"][id*="__main"]');

  if (dummyAtcBtn) dummyAtcBtn.classList.remove("hidden");
  if (goToBagBtn) goToBagBtn.classList.add("hidden");
  if (defaultAtcBtn) defaultAtcBtn.classList.add("hidden");

  if (stickyDummyBtn) stickyDummyBtn.classList.remove("hidden");
  if (stickyGoToBagBtn) stickyGoToBagBtn.classList.add("hidden");
  if (stickyAtcBtn) stickyAtcBtn.classList.add("hidden");

  function isDeselectChecked() {
    var deselect = document.querySelector('[id^="deselect-"]');
    return deselect ? deselect.checked : true;
  }

  function getCurrentVariantId() {
    var input = document.querySelector('input[name="id"]');
    return input ? parseInt(input.value) : null;
  }

  // === FIX: check whether the current PP variant is actually available ===
  // Used to guard against calling showDefaultAtc() when a sold-out variant is selected
  function isCurrentVariantAvailable() {
    // The deselect checkbox being checked means no size is selected
    if (isDeselectChecked()) return false;
    // Ask the PP notify button: if it's visible, the variant is unavailable (sold-out/notify state)
    if (ppNotifyBtn && !ppNotifyBtn.classList.contains('hidden')) return false;
    return true;
  }

  function showGoToBag() {
    if (dummyAtcBtn) dummyAtcBtn.classList.add("hidden");
    if (defaultAtcBtn) defaultAtcBtn.classList.add("hidden");
    if (goToBagBtn) goToBagBtn.classList.remove("hidden");
    if (stickyDummyBtn) stickyDummyBtn.classList.add("hidden");
    if (stickyAtcBtn) stickyAtcBtn.classList.add("hidden");
    if (stickyGoToBagBtn) stickyGoToBagBtn.classList.remove("hidden");
  }

  function showDefaultAtc() {
    // === FIX: clear disabled + subdued so the button looks correct when revealed ===
    if (defaultAtcBtn) {
      defaultAtcBtn.removeAttribute("disabled");
      defaultAtcBtn.classList.remove("button--subdued");
    }
    if (dummyAtcBtn) dummyAtcBtn.classList.add("hidden");
    if (goToBagBtn) goToBagBtn.classList.add("hidden");
    if (defaultAtcBtn) defaultAtcBtn.classList.remove("hidden");
    if (stickyDummyBtn) stickyDummyBtn.classList.add("hidden");
    if (stickyGoToBagBtn) stickyGoToBagBtn.classList.add("hidden");
    if (stickyAtcBtn) stickyAtcBtn.classList.remove("hidden");
    // === FIX: hide notify button — it must not show alongside the ATC button ===
    if (ppNotifyBtn) ppNotifyBtn.classList.add("hidden");
  }

  var _origFetch = window.fetch;
  window.fetch = function (resource, init) {
    var url = typeof resource === "string" ? resource : (resource && resource.url ? resource.url : "");
    var promise = _origFetch.apply(this, arguments);

    if (url.includes("/cart/add")) {
      promise.then(function (response) {
        if (response.ok) {
          setTimeout(function () {
            if (!isDeselectChecked() && !window._qvCartAddPending) {
              showGoToBag();
            }
            window._qvCartAddPending = false;
          }, 400);
        }
      }).catch(function () {});
    }

    if (url.includes("/cart/change") || url.includes("/cart/update")) {
      promise.then(function (response) {
        if (response.ok) {
          var clone = response.clone();
          clone.json().then(function (cart) {
            if (isDeselectChecked()) return;

            var variantId = getCurrentVariantId();
            if (!variantId) return;

            var stillInCart = cart.items && cart.items.some(function (item) {
              return item.variant_id === variantId;
            });

            if (!stillInCart) {
              // === FIX: Only revert to ATC if the current variant is actually available.
              // If it's a sold-out/notify variant, do NOT call showDefaultAtc() —
              // the notify state is already correct and we must not overwrite it. ===
              if (!isCurrentVariantAvailable()) return;

              setTimeout(function () {
                showDefaultAtc();
              }, 400);
            }
          }).catch(function () {});
        }
      }).catch(function () {});
    }

    return promise;
  };

});


// =============================================================
// NEW MODULE: Smart Button State
// Purpose: Additive only. Zero modification to existing code.
// Handles button visibility for products where a variant is
// pre-selected on page load (no deselect checkbox).
// Covers: Product page, Sticky ATC bar, Quick View drawer.
// =============================================================
(function () {

  // ── Helpers ──────────────────────────────────────────────────

  // Is a variant currently selected for this section?
  // "No deselect element" = product always has a default variant selected.
  // "Deselect exists but unchecked" = user has actively selected a variant.
  function sbs_isSelected(sectionId) {
    var deselect = sectionId
      ? document.getElementById('deselect-' + sectionId)
      : document.querySelector('[id^="deselect-"]');
    if (!deselect) return true;   // no deselect = always selected
    return !deselect.checked;     // unchecked = selected
  }

  // Get the current variant id for a section (or globally)
  function sbs_getVariantId(sectionId) {
    var input = sectionId
      ? (function () { var f = document.getElementById(sectionId); return f ? f.querySelector('input[name="id"]') : null; })()
      : document.querySelector('input[name="id"]');
    return input ? parseInt(input.value, 10) : 0;
  }

  // Look up a variant in the JSON data element for a section
  function sbs_getVariantData(sectionId, variantId) {
    var el = document.querySelector('#json-' + sectionId);
    if (!el || !variantId) return null;
    try {
      var arr = JSON.parse(el.textContent);
      return arr.find(function (v) { return v.id === variantId; }) || null;
    } catch (e) { return null; }
  }

  // Should this variant show "Join Waitlist"?
  function sbs_isSoldOut(vd) {
    if (!vd || vd.available) return false;
    return vd.hide_notify === '' || vd.hide_notify === 'false';
  }

  // ── Main page button actions ──────────────────────────────────

  function sbs_showRealATC() {
    var dummy    = document.querySelector('.custom-atc-button');
    var real     = document.querySelector('buy-buttons button[type="submit"]:not(.notify_submit)');
    var gtb      = document.querySelector('.custom-gtb-button');
    var stickyD  = document.querySelector('product-quick-add .custom_quick_add');
    var stickyA  = document.querySelector('product-quick-add buy-buttons');
    var stickyG  = document.querySelector('.sticky-gtb-button');
    var sectionId = sbs_getSectionId();
    var notifyBtn = sectionId ? document.querySelector('#notify-' + sectionId) : null;
    var notifyS   = sectionId ? document.querySelector('#notify-sticky-' + sectionId) : null;

    dummy   && dummy.classList.add('hidden');
    gtb     && gtb.classList.add('hidden');
    notifyBtn && notifyBtn.classList.add('hidden');
    if (real) {
      real.classList.remove('hidden');
      real.removeAttribute('disabled');
      real.classList.remove('button--subdued');
    }
    stickyD && stickyD.classList.add('hidden');
    stickyG && stickyG.classList.add('hidden');
    notifyS && notifyS.classList.add('hidden');
    stickyA && stickyA.classList.remove('hidden');
  }

  function sbs_showGTB() {
    var dummy    = document.querySelector('.custom-atc-button');
    var real     = document.querySelector('buy-buttons button[type="submit"]:not(.notify_submit)');
    var gtb      = document.querySelector('.custom-gtb-button');
    var stickyD  = document.querySelector('product-quick-add .custom_quick_add');
    var stickyA  = document.querySelector('product-quick-add buy-buttons');
    var stickyG  = document.querySelector('.sticky-gtb-button');
    var sectionId = sbs_getSectionId();
    var notifyBtn = sectionId ? document.querySelector('#notify-' + sectionId) : null;
    var notifyS   = sectionId ? document.querySelector('#notify-sticky-' + sectionId) : null;

    dummy   && dummy.classList.add('hidden');
    real    && real.classList.add('hidden');
    notifyBtn && notifyBtn.classList.add('hidden');
    gtb     && gtb.classList.remove('hidden');
    stickyD && stickyD.classList.add('hidden');
    stickyA && stickyA.classList.add('hidden');
    notifyS && notifyS.classList.add('hidden');
    stickyG && stickyG.classList.remove('hidden');
  }

  function sbs_showWaitlist() {
    var dummy    = document.querySelector('.custom-atc-button');
    var real     = document.querySelector('buy-buttons button[type="submit"]:not(.notify_submit)');
    var gtb      = document.querySelector('.custom-gtb-button');
    var stickyD  = document.querySelector('product-quick-add .custom_quick_add');
    var stickyA  = document.querySelector('product-quick-add buy-buttons');
    var stickyG  = document.querySelector('.sticky-gtb-button');
    var sectionId = sbs_getSectionId();
    var notifyBtn = sectionId ? document.querySelector('#notify-' + sectionId) : null;
    var notifyS   = sectionId ? document.querySelector('#notify-sticky-' + sectionId) : null;

    dummy   && dummy.classList.add('hidden');
    real    && real.classList.add('hidden');
    gtb     && gtb.classList.add('hidden');
    notifyBtn && notifyBtn.classList.remove('hidden');
    stickyD && stickyD.classList.add('hidden');
    stickyA && stickyA.classList.add('hidden');
    stickyG && stickyG.classList.add('hidden');
    notifyS && notifyS.classList.remove('hidden');
  }

  // ── Utility: get sectionId for main product page ──────────────

  function sbs_getSectionId() {
    var vp = document.querySelector('variant-picker');
    return vp ? vp.getAttribute('form') : null;
  }

  // ── Core: evaluate and apply the correct button state ─────────
  // Works for both main page and QV (pass sectionId for QV).

  function sbs_applyButtonState(sectionId, isQV) {
    if (!sbs_isSelected(sectionId)) return; // no variant selected — leave existing behavior

    var variantId   = sbs_getVariantId(sectionId);
    if (!variantId) return;

    var variantData = sbs_getVariantData(sectionId, variantId);

    // Sold out → show waitlist immediately (no fetch needed)
    if (sbs_isSoldOut(variantData)) {
      if (isQV) {
        sbs_qvShowWaitlist(sectionId);
      } else {
        sbs_showWaitlist();
      }
      return;
    }

    // Available → check cart
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = cart.items && cart.items.some(function (item) {
          return item.variant_id === variantId;
        });
        if (isQV) {
          inCart ? sbs_qvShowGTB(sectionId) : sbs_qvShowRealATC(sectionId);
        } else {
          inCart ? sbs_showGTB() : sbs_showRealATC();
        }
      })
      .catch(function () {
        if (!isQV) sbs_showRealATC();
        else sbs_qvShowRealATC(sectionId);
      });
  }

  // ── QV button actions ─────────────────────────────────────────

  function sbs_qvShowRealATC(sectionId) {
    var submit = document.querySelector('[form="' + sectionId + '"]>[type="submit"]:not(.notify_submit)');
    var dummy  = document.querySelector('[form="' + sectionId + '"]>[type="button"].custom-atc-button');
    var gtb    = document.querySelector('[form="' + sectionId + '"]>[type="button"].custom-gtb-button');
    var notify = document.querySelector('#notify-' + sectionId);
    dummy  && dummy.classList.add('hidden');
    gtb    && gtb.classList.add('hidden');
    notify && notify.classList.add('hidden');
    if (submit) {
      submit.classList.remove('hidden');
      submit.removeAttribute('disabled');
      submit.classList.remove('button--subdued');
    }
  }

  function sbs_qvShowGTB(sectionId) {
    var submit = document.querySelector('[form="' + sectionId + '"]>[type="submit"]:not(.notify_submit)');
    var dummy  = document.querySelector('[form="' + sectionId + '"]>[type="button"].custom-atc-button');
    var gtb    = document.querySelector('[form="' + sectionId + '"]>[type="button"].custom-gtb-button');
    var notify = document.querySelector('#notify-' + sectionId);
    submit && submit.classList.add('hidden');
    dummy  && dummy.classList.add('hidden');
    notify && notify.classList.add('hidden');
    gtb    && gtb.classList.remove('hidden');
  }

  function sbs_qvShowWaitlist(sectionId) {
    var submit = document.querySelector('[form="' + sectionId + '"]>[type="submit"]:not(.notify_submit)');
    var dummy  = document.querySelector('[form="' + sectionId + '"]>[type="button"].custom-atc-button');
    var gtb    = document.querySelector('[form="' + sectionId + '"]>[type="button"].custom-gtb-button');
    var notify = document.querySelector('#notify-' + sectionId);
    submit && submit.classList.add('hidden');
    dummy  && dummy.classList.add('hidden');
    gtb    && gtb.classList.add('hidden');
    notify && notify.classList.remove('hidden');
  }

  // ── Page load init ────────────────────────────────────────────

  function sbs_initMainPage() {
    var sectionId = sbs_getSectionId();
    sbs_applyButtonState(sectionId, false);
  }

  // ── variant:change listener (additive — runs alongside existing) ──
  // Handles the no-deselect case: after variant changes, re-evaluate button state.
  // Runs AFTER the existing handler (which shows both dummy + real ATC on variant change).

  document.addEventListener('variant:change', function (event) {
    var sectionId = $(event.target).attr('id');
    var isQV      = sectionId && sectionId.indexOf('quick-buy-form-') === 0;

    if (!sbs_isSelected(sectionId)) return; // deselect is checked — existing behavior handles it

    var variantId   = sbs_getVariantId(sectionId);
    var variantData = sbs_getVariantData(sectionId, variantId);

    if (sbs_isSoldOut(variantData)) {
      // Existing handler already shows notify — nothing to do
      return;
    }

    // For a normal available variant on variant:change:
    // The existing handler shows BOTH dummy + real ATC (the bug).
    // We hide the dummy immediately, then check cart for GTB.
    if (isQV) {
      // Existing QV handler manages its own state — only fix the dummy
      var qvDummy = document.querySelector('[form="' + sectionId + '"]>[type="button"].custom-atc-button');
      qvDummy && qvDummy.classList.add('hidden');
    } else {
      // Hide dummy on main page immediately
      var dummy = document.querySelector('.custom-atc-button');
      dummy && dummy.classList.add('hidden');
      // Sync sticky: show sticky ATC, hide sticky dummy
      var stickyD = document.querySelector('product-quick-add .custom_quick_add');
      var stickyA = document.querySelector('product-quick-add buy-buttons');
      stickyD && stickyD.classList.add('hidden');
      stickyA && stickyA.classList.remove('hidden');
    }

    // // Cart check: if this variant is already in cart, show GTB
    // if (variantId) {
    //   fetch('/cart.js')
    //     .then(function (r) { return r.json(); })
    //     .then(function (cart) {
    //       var inCart = cart.items && cart.items.some(function (item) {
    //         return item.variant_id === variantId;
    //       });
    //       if (inCart) {
    //         isQV ? sbs_qvShowGTB(sectionId) : sbs_showGTB();
    //       }
    //     })
    //     .catch(function () {});
    // }
  });

  var _sbsOrigFetch = window.fetch;
  window.fetch = function (resource, init) {
    var url = typeof resource === 'string'
      ? resource
      : (resource && resource.url ? resource.url : '');

    var isCartAdd = url.indexOf('/cart/add') !== -1;

    // ✅ Detect if request is from Quick View
    var isQVRequest = false;

    if (init && init.body && typeof init.body === 'string') {
      try {
        var params = new URLSearchParams(init.body);
        var formId = params.get('form_id') || params.get('sections');

        if (formId && formId.indexOf('quick-buy-form-') !== -1) {
          isQVRequest = true;
        }
      } catch (e) {}
    }

    var promise = _sbsOrigFetch.apply(this, arguments);

    // ── AFTER CART ADD ──────────────────────────────────────────
    if (isCartAdd) {
      promise.then(function (response) {
        if (!response.ok) return;

        // ❌ Ignore QV adds completely
        if (isQVRequest) return;

        var sectionId = sbs_getSectionId();

        // Only update if NOT sold out
        var variantId = sbs_getVariantId(sectionId);
        var variantData = sbs_getVariantData(sectionId, variantId);

        if (sbs_isSoldOut(variantData)) return; // ✅ KEEP WAITLIST

        if (sbs_isSelected(sectionId)) {
          setTimeout(function () {
            sbs_showGTB();
          }, 400);
        }
      }).catch(function () {});
    }

    // ── CART CHANGE (KEEP AS IS, BUT ADD SAME GUARD) ─────────────
    if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
      promise.then(function (response) {
        if (!response.ok) return;

        var clone = response.clone();
        clone.json().then(function (cart) {
          var sectionId = sbs_getSectionId();

          if (!sbs_isSelected(sectionId)) return;

          var variantId = sbs_getVariantId(sectionId);
          var variantData = sbs_getVariantData(sectionId, variantId);

          // ❗ IMPORTANT: Do not override WAITLIST state
          if (sbs_isSoldOut(variantData)) return;

          var stillInCart = cart.items && cart.items.some(function (item) {
            return item.variant_id === variantId;
          });

          if (!stillInCart) {
            setTimeout(function () {
              sbs_showRealATC();
            }, 400);
          }
        }).catch(function () {});
      }).catch(function () {});
    }

    return promise;
  };

  // ── Quick View: observe drawers and init button state on open ──

  function sbs_initQVDrawer(drawer) {
    var bb = drawer.querySelector('buy-buttons[form]');
    if (!bb) return;
    var sectionId = bb.getAttribute('form');
    if (!sectionId || sectionId.indexOf('quick-buy-form-') !== 0) return;
    sbs_applyButtonState(sectionId, true);
  }

  function sbs_attachDrawerObs(drawer) {
    if (drawer._sbsObserved) return;
    drawer._sbsObserved = true;
    var obs = new MutationObserver(function (mutations) {
      mutations.forEach(function (mut) {
        if (mut.attributeName === 'class') {
          var isVisible = drawer.classList.contains('show-close-cursor');
          if (isVisible) {
            // Run slightly after the existing qvInitDrawer (which runs at 100ms)
            // to ensure our state is applied last
            setTimeout(function () { sbs_initQVDrawer(drawer); }, 200);
          }
        }
      });
    });
    obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function sbs_observeDrawers() {
    document.querySelectorAll('quick-buy-drawer').forEach(sbs_attachDrawerObs);
    var domObs = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node.querySelectorAll) return;
          if (node.tagName === 'QUICK-BUY-DRAWER') sbs_attachDrawerObs(node);
          node.querySelectorAll('quick-buy-drawer').forEach(sbs_attachDrawerObs);
        });
      });
    });
    domObs.observe(document.body, { childList: true, subtree: true });
  }

  // ── Bootstrap ─────────────────────────────────────────────────
  // Uses a separate DOMContentLoaded (or runs immediately if already loaded).
  // Runs AFTER all existing handlers because it's appended at the end of the file.

  function sbs_boot() {
    // Small delay to let existing DOMContentLoaded handlers finish first
    setTimeout(function () {
      sbs_initMainPage();
      sbs_observeDrawers();
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sbs_boot);
  } else {
    sbs_boot();
  }

})();
// ============================================================
// END MODULE: Smart Button State
// ============================================================


// ============================================================
// QUICK VIEW: Separate isolated handler — does NOT touch product page buttons
// ============================================================
(function () {

  function qvShowGoToBag(sectionId) {
    var submitBtn = document.querySelector('[form="' + sectionId + '"]>[type="submit"]:not(.notify_submit)');
    var customAtc = document.querySelector('[form="' + sectionId + '"]>[type="button"].custom-atc-button');
    var customGtb = document.querySelector('[form="' + sectionId + '"]>[type="button"].custom-gtb-button');
    if (submitBtn) submitBtn.classList.add('hidden');
    if (customAtc) customAtc.classList.add('hidden');
    if (customGtb) customGtb.classList.remove('hidden');
  }

  function qvShowDefaultAtc(sectionId) {
    var submitBtn = document.querySelector('[form="' + sectionId + '"]>[type="submit"]:not(.notify_submit)');
    var customAtc = document.querySelector('[form="' + sectionId + '"]>[type="button"].custom-atc-button');
    var customGtb = document.querySelector('[form="' + sectionId + '"]>[type="button"].custom-gtb-button');
    if (customGtb) customGtb.classList.add('hidden');
    if (customAtc) customAtc.classList.add('hidden');
    if (submitBtn) submitBtn.classList.remove('hidden');
  }

  function qvInitDrawer(drawer) {
    var bb = drawer.querySelector('buy-buttons[form]');
    if (!bb) return;
    var sectionId = bb.getAttribute('form');
    if (!sectionId || sectionId.indexOf('quick-buy-form-') !== 0) return;

    var deselect = document.getElementById('deselect-' + sectionId);
    if (deselect && deselect.checked) return;

    var sectionForm = document.getElementById(sectionId);
    if (!sectionForm) return;
    var idInput = sectionForm.querySelector('input[name="id"]');
    var variantId = idInput ? parseInt(idInput.value) : 0;
    if (!variantId) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var isInCart = cart.items && cart.items.some(function (item) {
          return item.variant_id === variantId;
        });
        if (isInCart) {
          qvShowGoToBag(sectionId);
        } else {
          qvShowDefaultAtc(sectionId);
        }
      })
      .catch(function () {});
  }

  var _activQvSectionId = null;

  document.addEventListener('click', function (e) {
    var drawer = e.target.closest('quick-buy-drawer');
    if (!drawer) return;

    var bb = drawer.querySelector('buy-buttons[form]');
    if (!bb) return;
    var sectionId = bb.getAttribute('form');
    if (!sectionId || sectionId.indexOf('quick-buy-form-') !== 0) return;

    var btn = e.target.closest('button[type="submit"], button.custom-atc-button');
    if (!btn) return;

    _activQvSectionId = sectionId;
    window._qvCartAddPending = true;
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    var _ppWrappedFetch = window.fetch;

    window.fetch = function (resource, init) {
      var url = typeof resource === 'string' ? resource : (resource && resource.url ? resource.url : '');
      var promise = _ppWrappedFetch.apply(this, arguments);

      if (url.indexOf('/cart/add') !== -1) {
        var capturedSectionId = _activQvSectionId;
        if (capturedSectionId) {
          promise.then(function (response) {
            if (response.ok) {
              setTimeout(function () {
                qvShowGoToBag(capturedSectionId);
              }, 450);
            }
          }).catch(function () {});
          _activQvSectionId = null;
        }
      }

      if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
        promise.then(function (response) {
          if (response.ok) {
            var clone = response.clone();
            clone.json().then(function (cart) {
              document.querySelectorAll('quick-buy-drawer').forEach(function (drawer) {
                var rect = drawer.getBoundingClientRect();
                if (rect.width === 0 || rect.height === 0) return;

                var bb = drawer.querySelector('buy-buttons[form]');
                if (!bb) return;
                var sid = bb.getAttribute('form');
                if (!sid || sid.indexOf('quick-buy-form-') !== 0) return;

                var deselect = document.getElementById('deselect-' + sid);
                if (deselect && deselect.checked) return;

                var sectionForm = document.getElementById(sid);
                if (!sectionForm) return;
                var idInput = sectionForm.querySelector('input[name="id"]');
                var variantId = idInput ? parseInt(idInput.value) : 0;
                if (!variantId) return;

                var stillInCart = cart.items && cart.items.some(function (item) {
                  return item.variant_id === variantId;
                });

                setTimeout(function () {
                  if (stillInCart) {
                    qvShowGoToBag(sid);
                  } else {
                    qvShowDefaultAtc(sid);
                  }
                }, 450);
              });
            }).catch(function () {});
          }
        }).catch(function () {});
      }

      return promise;
    };
  });

  function observeDrawers() {
    function attachDrawerObserver(drawer) {
      if (drawer._qvObserved) return;
      drawer._qvObserved = true;

      var obs = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName !== 'class') return;
          var isVisible = drawer.classList.contains('show-close-cursor');
          if (isVisible) {
            setTimeout(function () { qvInitDrawer(drawer); }, 100);
          }
        });
      });

      obs.observe(drawer, { attributes: true, attributeFilter: ['class'], subtree: false });
    }

    document.querySelectorAll('quick-buy-drawer').forEach(attachDrawerObserver);

    var domObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node.querySelectorAll) return;
          if (node.tagName === 'QUICK-BUY-DRAWER') {
            attachDrawerObserver(node);
          }
          node.querySelectorAll('quick-buy-drawer').forEach(attachDrawerObserver);
        });
      });
    });

    domObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawers);
  } else {
    observeDrawers();
  }

})();

//end add to cart button







// Initial load disable ATC btn Start
document.addEventListener('DOMContentLoaded', () => {
  function atcBtnDisable(){
    let pdp_atc_btn = document.querySelectorAll('buy-buttons.buy-buttons button[type="submit"]');
      pdp_atc_btn?.forEach((atc_btn) => {
        atc_btn.setAttribute('disabled', '');
        atc_btn.classList.add('button--subdued');
      })
  }
  atcBtnDisable();
  document.addEventListener('custom:quick-buy', () => {
    setTimeout(atcBtnDisable, 1100)
  })
});
// Initial load disable ATC btn End

// Cart Animate Text
$(document).ready(function() {cartTextChange();});
function cartTextChange(){
  if(animate_text.length > 0){
    const time_limit = 1200;
    let currentIndex = 0;
    setInterval(function() {
      (currentIndex === animate_text.length - 1)?currentIndex = 0:currentIndex = currentIndex + 1;
      $('.step-name[id="bar-names"]').text(animate_text[currentIndex]);
      $('.step-name[id="bar-name"]').text(animate_text[currentIndex]);
    }, time_limit); 
  }
}

$(document).ready(function() {
  // product page sticky Start
  // $('.custom_quick_add button').click(function() {
  //   $('html, body').animate({
  //       scrollTop: $('.product-info__variant-picker').offset().top
  //     }, 500);
  //   return false;
  // });

  document.addEventListener("click", function (e) {

    const dummyBtn = e.target.closest(".product-info__buy-buttons .custom-atc-button, .quick-buy-drawer .custom-atc-button");
    if (!dummyBtn) return;

    // 🔥 Scope to current container (important fix)
    const container = dummyBtn.closest(".product-info, .quick-buy-drawer");

    const fieldset = container?.querySelector(".size_option_field");
    const sizeWrapper = fieldset?.querySelector(".variant-picker__option-values");

    if (!fieldset || !sizeWrapper) return;

    // Check if user selected size inside THIS container only
    const userSelected = fieldset.querySelector('[data-size-option]:checked') &&
                        !fieldset.querySelector('.deselect:checked');

    if (!userSelected) {

      const existingError = fieldset.querySelector(".size-error-msg");
      if (existingError) existingError.remove();

      const errorMsg = document.createElement("p");
      errorMsg.className = "size-error-msg";
      errorMsg.innerText = "Please select a size";

      sizeWrapper.parentNode.insertBefore(errorMsg, sizeWrapper);

      sizeWrapper.classList.remove("shake");

      setTimeout(() => {
        sizeWrapper.classList.add("shake");
      }, 10);

      sizeWrapper.scrollIntoView({ behavior: "smooth", block: "center" });

      return;
    }

  });


  // ✅ Remove error (scoped fix)
  $(document).on('change click', '[data-size-option], .size_option_field label', function () {

    // 🔥 Scope properly
    const container = $(this).closest(".product-info, .quick-buy-drawer")[0];
    const fieldset = container?.querySelector(".size_option_field");

    if (!fieldset) return;

    const userSelected = fieldset.querySelector('[data-size-option]:checked') &&
                        !fieldset.querySelector('.deselect:checked');

    if (userSelected) {
      const errorMsg = fieldset.querySelector(".size-error-msg");
      if (errorMsg) errorMsg.remove();
    }
  });


  $('.custom_quick_add button').on('click', function (e) {
    console.log('customm');

    e.preventDefault();

    const fieldset = document.querySelector(".size_option_field");
    const sizeWrapper = fieldset?.querySelector(".variant-picker__option-values");

    if (!fieldset || !sizeWrapper) {
      console.log("❌ sizeWrapper not found");
      return;
    }

    // 🔥 Check size selected
    const userSelected = document.querySelector('[data-size-option]:checked') &&
                        !document.querySelector('.deselect:checked');

    // 👉 Scroll first
    $('html, body').animate({
      scrollTop: $('.product-info__variant-picker').offset().top
    }, 500, function () {

      // 👇 AFTER SCROLL COMPLETE

      if (!userSelected) {

        // ✅ Remove old error
        const existingError = fieldset.querySelector(".size-error-msg");
        if (existingError) existingError.remove();

        // ✅ Create error message
        const errorMsg = document.createElement("p");
        errorMsg.className = "size-error-msg";
        errorMsg.innerText = "Please select a size";

        // 👉 Insert BEFORE sizeWrapper
        sizeWrapper.parentNode.insertBefore(errorMsg, sizeWrapper);

        // 🔥 Shake animation
        sizeWrapper.classList.remove("shake");

        setTimeout(() => {
          sizeWrapper.classList.add("shake");
          console.log("✅ shake added AFTER scroll");
        }, 50);

        return;
      }

    });

  });
  
  // product page Sticky End

  // Shopall filter Buttom Smooth Scroll start
  $('[tap-title]').click(function() {
    let id = $(this).attr('tap-title');
    let header = document.querySelector('store-header[sticky]');
    let header_height = 0;
    if(header != undefined && header != null){
      header_height = header.offsetHeight;
    }
    let filter_section = $(this).parents('[sticky-filter]')[0];
    let filter_section_height = 0;
    if(filter_section != undefined && filter_section != null){
      filter_section_height = filter_section.offsetHeight;
    }
    let position = header_height + filter_section_height - 1;
    let target = $('[tap-content="'+id+'"]').parents('section').offset();
    if(target != undefined && target != null ){
      $('html, body').animate({
          scrollTop: target.top - position
      }, 500);
    }
    return false;
  });
  // Shopall filter Buttom Smooth Scroll end

  $('.quick-purchase-bar__hide').click(function() {
    $(this).parents('.custom-sticky-add').toggleClass('active');
    console.log($(this).parents('.custom-sticky-add').outerHeight());
    let height = $(this).parents('.custom-sticky-add').outerHeight() - 10;
    $(".custom-sticky-add.is-visible").css("transform", '');
    $(".custom-sticky-add.is-visible.active").css("transform", 'translateY('+height+'px)');
  });
});

// bliss coins Popup Login Start
$(document).ready(function() {
  $('.bliss-login-popup [href="#login"]').click(function(e) {
    $('.bliss-login-popup #login').removeAttr('hidden',true);
    $('.bliss-login-popup #register').attr('hidden',true);
    $('.bliss-login-popup #recover').attr('hidden',true);
  });
  $('.bliss-login-popup [href="#register"]').click(function(e) {
    $('.bliss-login-popup #login').attr('hidden',true);
    $('.bliss-login-popup #register').removeAttr('hidden',true);
    $('.bliss-login-popup #recover').attr('hidden',true);
  });
  $('.bliss-login-popup [href="#recover"]').click(function(e) {
    $('.bliss-login-popup #login').attr('hidden',true);
    $('.bliss-login-popup #register').attr('hidden',true);
    $('.bliss-login-popup #recover').removeAttr('hidden',true);
  });
});
// bliss coins Popup Login End

// rewards Page Start
function getRewards() {
  let result_html = document.querySelector('.header_bliss_coins');
  let is_customer = result_html.getAttribute("data-customer");
  let customer_email = result_html.getAttribute("data-email");
  let customer_id = result_html.getAttribute("data-id");
  let logged_out_url = result_html.getAttribute("data-logged_out_url");
  let logged_in_url = result_html.getAttribute("data-logged_in_url");
  const svgHml = `<svg width="49" height="52" viewBox="0 0 49 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_106_11" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="49" height="52">
<rect width="49" height="51.8" fill="#D9D9D9"/>
<rect width="49" height="51.8" stroke="black"/>
</mask>
<g mask="url(#mask0_106_11)">
<path d="M22.2949 35.2917L37.5112 20.0754L34.4895 17.0538L22.2949 29.2483L16.1437 23.0971L13.122 26.1188L22.2949 35.2917ZM25.3166 46.9467C22.3309 46.9467 19.5251 46.3801 16.8991 45.247C14.2731 44.1139 11.9889 42.576 10.0464 40.6335C8.1039 38.691 6.56609 36.4068 5.43296 33.7808C4.29984 31.1549 3.73328 28.349 3.73328 25.3633C3.73328 22.3776 4.29984 19.5718 5.43296 16.9458C6.56609 14.3199 8.1039 12.0356 10.0464 10.0931C11.9889 8.15063 14.2731 6.61282 16.8991 5.47969C19.5251 4.34657 22.3309 3.78 25.3166 3.78C28.3023 3.78 31.1081 4.34657 33.7341 5.47969C36.3601 6.61282 38.6443 8.15063 40.5868 10.0931C42.5293 12.0356 44.0671 14.3199 45.2003 16.9458C46.3334 19.5718 46.8999 22.3776 46.8999 25.3633C46.8999 28.349 46.3334 31.1549 45.2003 33.7808C44.0671 36.4068 42.5293 38.691 40.5868 40.6335C38.6443 42.576 36.3601 44.1139 33.7341 45.247C31.1081 46.3801 28.3023 46.9467 25.3166 46.9467ZM25.3166 42.63C30.1369 42.63 34.2197 40.9573 37.5652 37.6119C40.9106 34.2665 42.5833 30.1836 42.5833 25.3633C42.5833 20.5431 40.9106 16.4602 37.5652 13.1148C34.2197 9.76938 30.1369 8.09667 25.3166 8.09667C20.4963 8.09667 16.4135 9.76938 13.0681 13.1148C9.72265 16.4602 8.04994 20.5431 8.04994 25.3633C8.04994 30.1836 9.72265 34.2665 13.0681 37.6119C16.4135 40.9573 20.4963 42.63 25.3166 42.63Z" fill="white"/>
<path d="M22.2949 35.2917L37.5112 20.0754L34.4895 17.0538L22.2949 29.2483L16.1437 23.0971L13.122 26.1188L22.2949 35.2917ZM25.3166 46.9467C22.3309 46.9467 19.5251 46.3801 16.8991 45.247C14.2731 44.1139 11.9889 42.576 10.0464 40.6335C8.1039 38.691 6.56609 36.4068 5.43296 33.7808C4.29984 31.1549 3.73328 28.349 3.73328 25.3633C3.73328 22.3776 4.29984 19.5718 5.43296 16.9458C6.56609 14.3199 8.1039 12.0356 10.0464 10.0931C11.9889 8.15063 14.2731 6.61282 16.8991 5.47969C19.5251 4.34657 22.3309 3.78 25.3166 3.78C28.3023 3.78 31.1081 4.34657 33.7341 5.47969C36.3601 6.61282 38.6443 8.15063 40.5868 10.0931C42.5293 12.0356 44.0671 14.3199 45.2003 16.9458C46.3334 19.5718 46.8999 22.3776 46.8999 25.3633C46.8999 28.349 46.3334 31.1549 45.2003 33.7808C44.0671 36.4068 42.5293 38.691 40.5868 40.6335C38.6443 42.576 36.3601 44.1139 33.7341 45.247C31.1081 46.3801 28.3023 46.9467 25.3166 46.9467ZM25.3166 42.63C30.1369 42.63 34.2197 40.9573 37.5652 37.6119C40.9106 34.2665 42.5833 30.1836 42.5833 25.3633C42.5833 20.5431 40.9106 16.4602 37.5652 13.1148C34.2197 9.76938 30.1369 8.09667 25.3166 8.09667C20.4963 8.09667 16.4135 9.76938 13.0681 13.1148C9.72265 16.4602 8.04994 20.5431 8.04994 25.3633C8.04994 30.1836 9.72265 34.2665 13.0681 37.6119C16.4135 40.9573 20.4963 42.63 25.3166 42.63Z" stroke="black"/>
</g>
</svg>
`;
  const merchand_id = 70239;
  let create_html = ``;

  if(is_customer == 'true'){
    fetchTokenJSON().then(result => {
      // console.log(result);
      let url = 'https://loyalty.yotpo.com/api/v1/customer_details?customer_email='+result.email+'&customer_external_id='+result.id+'&customer_token='+result.token+'&merchant_id='+merchand_id;
      fetchCustomerJSON(url).then(detail => {
        // console.log('detail',detail);
        // $('.earned-coins').text(detail.points_balance);
        // $('.bliss_coins').text(detail.points_balance);
        $('.earned-coins').text(detail.points_earned);
        $('.bliss_coins').text(detail.points_earned);
        const customer_campaigns = detail.campaigns;
        // console.log(customer_campaigns);
        
        // create_html += `<div class="page-width">`;
        create_html += `<div class="rewards_row">`;
        swellAPI.getActiveCampaigns().forEach(campaign => {
          const customer_object = {
            'customer_email': result.email,
            'customer_external_id': result.id,
            'customer_token': result.token,
            'merchant_id': 70239
            };
          const campan_items = customer_campaigns.filter(campain_item => campain_item.id == campaign.id);
          // console.log(campan_items[0]);
          // console.log(campaign);
          create_html +=`<div class="rewards_item">`;
            create_html +=`<div class="rewards_box">`;
            if(campan_items){
              if(campan_items[0].customerPerksCompleted == 1){
                create_html +=`<div class="rewards_completed">`;
                  create_html +=`<div class="rewards_completed_box">`;
                    create_html += svgHml;
                    create_html +=`<h2 class="bold rewards_points">${ campaign.rewardPoints }</h2>`;
                    create_html +=`<p class="rewards_points_text">Blisscoins</p>`;
                  create_html += `</div>`;
                create_html += `</div>`;
              } else {
                create_html +=getbtnText(campaign, customer_object);
              }
            }else{
              create_html +=getbtnText(campaign, customer_object);
            }
            create_html += `</div>`;
            create_html +=`<h3 class="rewards_heading">${ campaign.title }</h3>`;
          create_html += `</div>`;
        });
        create_html += `</div>`;
        // create_html += `</div>`;
        
        $('#custom-campaign-result').html(create_html);
      });
    });
  } else {
    // create_html += `<div class="page-width">`;
    create_html += `<div class="rewards_row">`;
    swellAPI.getActiveCampaigns().forEach(campaign => {
      // console.log(campaign);
      create_html +=`<div class="rewards_item">`;
        create_html +=`<div class="rewards_box">`;
          create_html += getbtnText(campaign, null);
          // create_html +=`<div class="rewards_step1">`;
          //   create_html +=`<h2 class="rewards_points">${ campaign.rewardPoints }</h2>`;
          //   create_html +=`<p class="rewards_points_text">Blisscoins</p>`;
          //   create_html +=`<a class="swell-campaign-link btn-${campaign.icon} reward-btn" href="javascript:void(0);" data-campaign-id="${campaign.id}" data-display-mode="modal">${getbtnText(campaign, null)}</a>`;
          // create_html += `</div>`;
          create_html +=`<div class="rewards_step2">`;
            create_html +=`<a href="javascript:void(0);" class="rewards_login" aria-controls="login-popup" aria-expanded="false" data-customer="${is_customer}" data-email="${customer_email}" data-id="${customer_id}">Log in & Sign up</a>`;
          create_html += `</div>`;
        create_html += `</div>`;
        create_html +=`<h3 class="rewards_heading">${ campaign.title }</h3>`;
      create_html += `</div>`;
    });
    create_html += `</div>`;
    // create_html += `</div>`;
  $('#custom-campaign-result').html(create_html);
  }

}

async function fetchTokenJSON() {
  const response = await fetch('https://blissclub.com/apps/loggedincustomer');
  const movies = await response.json();
  return movies;
}
async function fetchCustomerJSON(url) {
  const response = await fetch(url);
  const movies = await response.json();
  return movies;
}

function instaFollowUs(target) {
  if(target.getAttribute("data-email") != '' && target.getAttribute("data-id") != ''){
    const apiKey = 'TNzbyFVXdGZ1FITUzJL8Awtt';
  
    // Endpoint URL
    const url = 'https://loyalty.yotpo.com/api/v1/user_actions';
    
    // Example data for the API call, replace with your own data if needed
    const data = {
        "type": target.getAttribute("data-type"),
        "campaign_id": target.getAttribute("data-campain-id"),
        "customer_email": target.getAttribute("data-email"),
        "customer_external_id": target.getAttribute("data-id"),
        "customer_token": target.getAttribute("data-token"),
        "merchant_id": 70239
      };
    
    // Request headers with the API key
    const headers = {
      Authorization: `Bearer ${apiKey}`,
      'Content-Type': 'application/json'
    };
    
    fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    })
    .then(response => {
      // Check if the response was successful
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // Handle the API response data
      console.log('Response data:', data);
      if(data){
        getRewards();
      }
    })
    .catch(error => {
      // Handle errors
      console.error('API call failed:', error.message);
    });
    
  }
}

function getbtnText(campaign, customer_object){
  let text = campaign.icon;
  let campaign_id = campaign.id;
  let email = (customer_object != null)?customer_object.customer_email: '';
  let id = (customer_object != null)?customer_object.customer_external_id: '';
  let token = (customer_object != null)?customer_object.customer_token: '';
  let merchant_id = (customer_object != null)?customer_object.merchant_id: '';

  let create_html = ``;
  switch (text) {
    case "fa-book":
      create_html +=`<div class="rewards_step1">`;
        create_html +=`<h2 class="bold rewards_points">${ campaign.rewardPoints }</h2>`;
        create_html +=`<p class="rewards_points_text">Blisscoins</p>`;
        create_html +=`<a class="swell-campaign-link btn-${campaign.icon} reward-btn" href="javascript:void(0);" data-campaign-id="${campaign.id}" data-display-mode="modal">Read</a>`;
      create_html += `</div>`;
      return create_html;
      break;
    case "fa-star":
      create_html +=`<div class="rewards_step1">`;
        create_html +=`<h2 class="bold rewards_points">${ campaign.rewardPoints }</h2>`;
        create_html +=`<p class="rewards_points_text">Blisscoins</p>`;
        create_html +=`<a class="swell-campaign-link btn-${campaign.icon} reward-btn" href="javascript:void(0);" data-campaign-id="${campaign.id}" data-display-mode="modal">Review</a>`;
      create_html += `</div>`;
      return create_html;
      break;
    case "fa-birthday-cake":
      create_html +=`<div class="rewards_step1">`;
        create_html +=`<h2 class="bold rewards_points">${ campaign.rewardPoints }</h2>`;
        create_html +=`<p class="rewards_points_text">Blisscoins</p>`;
        create_html +=`<a class="swell-campaign-link btn-${campaign.icon} reward-btn" href="javascript:void(0);" data-campaign-id="${campaign.id}" data-display-mode="modal">Tell Us</a>`;
      create_html += `</div>`;
      return create_html;
      break;
    case "fa-shopping-cart":
      create_html +=`<div class="rewards_step1">`;
        create_html +=`<h2 class="bold rewards_points">${ campaign.rewardPoints }</h2>`;
        create_html +=`<p class="rewards_points_text">Blisscoins</p>`;
        create_html +=`<a class="swell-campaign-link btn-${campaign.icon} reward-btn" href="javascript:void(0);" data-campaign-id="${campaign.id}" data-display-mode="modal">Shop Now</a>`;
      create_html += `</div>`;
      return create_html;
      break;
    case "fa-heart":
      create_html +=`<div class="rewards_step1">`;
        create_html +=`<h2 class="bold rewards_points">${ campaign.rewardPoints }</h2>`;
        create_html +=`<p class="rewards_points_text">Blisscoins</p>`;
        create_html +=`<a class="swell-campaign-link btn-${campaign.icon} reward-btn" href="javascript:void(0);" data-campaign-id="${campaign.id}" data-display-mode="modal">Refer</a>`;
      create_html += `</div>`;
      return create_html;
      break;
    case "fa-dollar":
      create_html +=`<div class="rewards_step1">`;
        create_html +=`<h2 class="bold rewards_points">${ campaign.rewardPoints }</h2>`;
        create_html +=`<p class="rewards_points_text">Blisscoins</p>`;
        create_html +=`<a class="swell-campaign-link btn-${campaign.icon} reward-btn" href="javascript:void(0);" data-campaign-id="${campaign.id}" data-display-mode="modal">Shop Now</a>`;
      create_html += `</div>`;
      return create_html;
      break;
    case "fa-instagram":
      create_html +=`<div class="rewards_step1">`;
        create_html +=`<h2 class="bold rewards_points">${ campaign.rewardPoints }</h2>`;
        create_html +=`<p class="rewards_points_text">Blisscoins</p>`;
        create_html +=`<a class="swell-campaign-link btn-${campaign.icon} reward-btn" href="javascript:void(0);" onclick="instaFollowUs(this)" data-email="${email}" data-id="${id}" data-campain-id="${campaign_id}" data-token="${token}" data-type="InstagramFollow">Follow Us</a>`;
      create_html += `</div>`;
      return create_html;
      break;
    case "fa-user":
      create_html +=`<div class="rewards_step1">`;
        create_html +=`<h2 class="bold rewards_points">${ campaign.rewardPoints }</h2>`;
        create_html +=`<p class="rewards_points_text">Blisscoins</p>`;
        create_html +=`<a class="swell-campaign-link btn-${campaign.icon} reward-btn" href="javascript:void(0);" data-campaign-id="${campaign.id}" data-display-mode="modal">Sign Up</a>`;
      create_html += `</div>`;
      return create_html;
      break;
    default:
      create_html +=`<div class="rewards_step1">`;
        create_html +=`<h2 class="bold rewards_points">${ campaign.rewardPoints }</h2>`;
        create_html +=`<p class="rewards_points_text">Blisscoins</p>`;
        create_html +=`<a class="swell-campaign-link btn-${campaign.icon} reward-btn" href="javascript:void(0);" data-campaign-id="${campaign.id}" data-display-mode="modal">details</a>`;
      create_html += `</div>`;
      return create_html;
      break;
  }
}

function redeemNow(target){
  if(target.getAttribute("data-cart") > 0){
    // openFloCheckout();
    $('.gokwik-checkout button').click();
  } else {
    window.location.href = target.getAttribute("data-url");
  }
}

function setCookie(name,value,days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
// Reward Page End

// sidebar wishlist
$(document).ready(function() {
  var count = $(".header__icon-list .wishlist-header-section .wishlist-count").text();
  $(".icons-list .wishlist-header-section .wishlist-count").append(count);
});

// document.addEventListener("variant:change", (event) => {
//   $("fieldset input[type='radio'][data-size-option]:checked").prop('checked', false);
// },{once : true});
document.addEventListener("custom:quick-buy", (event) => {
  setTimeout(function(){
    $("quick-buy-drawer fieldset input[type='radio'][data-size-option]:checked").prop('checked', false);
  },1000);
});

$(document).ready(function() {
  document.addEventListener("custom:filter-tab", (event) => {
    $( ".collection-page-tab .collection-filter-tab, .collection-page-tab .collection-filter-tab-img" ).on( "click", function() {
      // console.log($(this).parents('image-link-blocks').find('.collection-filter-tab'));
      if($(this).hasClass('active')){
        $(this).parents('image-link-blocks').find('[filter-key]').each(function( index ) {
          $(this).removeClass('active');
        });
        $(this).parents('image-link-blocks').find('.collection-filter-tab.active_first').addClass('active');
      }else{
        $(this).parents('image-link-blocks').find('[filter-key]').each(function( index ) {
          $(this).removeClass('active');
        });
        $(this).addClass('active')
      }
      let cur_value_1 = $('.collection-page-tab .collection-filter-tab.active').attr('filter-key');
      let cur_value_2 = $('.collection-page-tab .collection-filter-tab-img.active').attr('filter-key');
      if(cur_value_1 === undefined && cur_value_2 === undefined){
        $('.collection-page-tab .product-list>.product-card[activity-filter]').each(function( index ) {
          $( this ).show();
        });
        return;
      }

      $('.collection-page-tab .product-list>.product-card[activity-filter]').each(function( index ) {
        if(cur_value_1 != undefined && cur_value_2 != undefined){
          if($(this).attr('activity-filter').includes(cur_value_1) && $(this).attr('activity-filter').includes(cur_value_2)){
            $( this ).show();
          } else {
            $( this ).hide();
          }
        }else if(cur_value_1 != undefined && cur_value_2 === undefined){
          if($(this).attr('activity-filter').includes(cur_value_1)){
            $( this ).show();
          } else {
            $( this ).hide();
          }
        }else if(cur_value_1 === undefined && cur_value_2 != undefined){
          if($(this).attr('activity-filter').includes(cur_value_2)){
            $( this ).show();
          } else {
            $( this ).hide();
          }
        }
      });
      
      // if($(this).hasClass('active')){
      //   $('.collection-page-tab .collection-filter-tab').removeClass('active');
      //   $('.collection-page-tab .product-list>.product-card[activity-filter]').each(function( index ) {
      //     $( this ).show();
      //   });
      // } else {
      //   let cur_value = $(this).attr('filter-key');
      //   $('.collection-page-tab .collection-filter-tab').removeClass('active');
      //   $(this).addClass('active');
      //   // console.log(cur_value);
      //   $('.collection-page-tab .product-list>.product-card[activity-filter]').each(function( index ) {
      //     if($(this).attr('activity-filter').includes(cur_value)){
      //       $( this ).show();
      //     } else {
      //       $( this ).hide();
      //     }
      //   });
      // }
    });
  });
  
  document.dispatchEvent(new CustomEvent("custom:filter-tab", {
    bubbles: true
  }));

  $(".custom-menu").hover(function() {
    var isHovered = $(this).is(":hover");
    if (isHovered) {
      $(this).children(".custom-drop-down").stop().slideDown(300);
    } else {
      $(this).children(".custom-drop-down").stop().slideUp(300);
    }
  });
});


// Swiper Slide Center Align
function slideCenterAlign(swiper) {
  let container = swiper.el;
  if (container) {
    let containerWidth = container.offsetWidth;
    let totalSlidesWidth = 0;

    let slidesGrid = swiper.slidesGrid;
    if (slidesGrid.length > 0) {
      totalSlidesWidth = slidesGrid[slidesGrid.length - 1] + swiper.slides[swiper.slides.length - 1].offsetWidth;
    }
    
    // Check if the slides are scrollable
    if (totalSlidesWidth > containerWidth) {
      container.classList.remove('slide-not-scrollable');
    } else {
      container.classList.add('slide-not-scrollable');
    }
  }
}

// Video section Mute option Start
$(document).ready(function() {
  let muteButtons = document.querySelectorAll(".video-mute-btn");
  muteButtons.forEach(function(button) {
    button.addEventListener("click", function() {
      let video = this.nextElementSibling.querySelector("video");
      if (video.muted) {
        video.muted = false;
        button.querySelector('.mute').setAttribute("hidden", true);
        button.querySelector('.unmute').removeAttribute("hidden");
      } else {
        video.muted = true;
        button.querySelector('.mute').removeAttribute("hidden");
        button.querySelector('.unmute').setAttribute("hidden", true);
      }
    });
  });
});
// Video section Mute option End

$(document).ready(function() {
  $(".size-chart-tabs .size-chart-tab").on("click", function() {
    // Get the attribute value using 'this'
    let value = $(this).data("title");
    if(!$(this).hasClass("active")) {
      $(`.size-chart-tabs .size-chart-tab`).removeClass('active');
      $(this).addClass('active');
      $(`.size-chart-content .size-tab-content`).removeClass('active').attr('hidden',true);
      $(`.size-chart-content [data-tab="${value}"]`).addClass('active').removeAttr('hidden');
    }
  });

  $(".size-chart-toggle").click(function() {
      $(".btn-toggle").toggleClass('move');
      $(".inch-btn").toggleClass('push');
      if ($(".size-chart-cm").attr('hidden')) {
        $(".size-chart-cm").removeAttr('hidden');
      } else {
        $(".size-chart-cm").attr('hidden', 'true');
      }
      if ($(".size-chart-inch").attr('hidden')) {
        $(".size-chart-inch").removeAttr('hidden');
      } else {
        $(".size-chart-inch").attr('hidden', 'true');
      }
  });
});

// Offer Discount Slide Js Start
$(document).ready(function() {
  var swiper = new Swiper(".offer-box .offer-slider", {
    slidesPerView: 1.1,
    spaceBetween: 12,
    centeredSlides: false,
    loop: false,
    slidesOffsetAfter: 50,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    breakpoints: {
      1300: {
        slidesPerView: 1.8,
        spaceBetween: 14,
        slidesOffsetAfter: 0,
      },
      500: {
        slidesPerView: 1.4,
        spaceBetween: 12,
        slidesOffsetAfter: 0,
      },
    },
  });
});

// copy Script Js
document.addEventListener('DOMContentLoaded', function () {
  // let offerWrapper = document.querySelectorAll('.offer__slidezs_container .offer');
  
  // offerWrapper.forEach((offerBlock) => {
  //   console.log(offerBlock, "offerBlock");
  
  //   let innerSection = offerBlock.querySelector('.offers-section');
    
  //   if(innerSection){
  //     innerSection.addEventListener('click', (e) => { // Corrected 'addEvenListener' to 'addEventListener'
  //       e.preventDefault();
  //       console.log(e, "tag");
  //     });
  //   }
  // });
  
    let offerWrapper = document.querySelectorAll('.offer__slidezs_container .offer');
      offerWrapper.forEach(offerBlock => {
      let innerSection = offerBlock.querySelector('.offers-section');
        innerSection.addEventListener('click', function(e) {
            const discountText = innerSection.querySelector('.discount__code_offer').innerText;
            // console.log(discountText, "discountText")
            navigator.clipboard.writeText(discountText).then(() => {
                // console.log('Discount code copied: ' + discountText);
              
              var copyText = innerSection.querySelector(".code__off_container");
              if(copyText){
                copyText.classList.add("textCopied");
                  setTimeout(() => {
                     copyText.classList.remove("textCopied");
                  }, 5000)
              }
              
            }).catch(err => {
                console.log('Failed to copy text: ', err);
            });
        });
    });

    // document.querySelectorAll('.copy-svg').forEach(copyButton => {
    //     copyButton.addEventListener('click', function(e) {
    //         const discountText = this.closest('.code__off_container').querySelector('.discount__code_offer').innerText;
    //         console.log(discountText, "discountText")
    //         navigator.clipboard.writeText(discountText).then(() => {
    //             // console.log('Discount code copied: ' + discountText);
              
    //           var copyText = document.querySelectorAll(".offer-box .offer-slider .offer .offer-item .offer__code_split .code__off_container");
    //           copyText.forEach(element => {
    //               element.classList.add("textCopied");
    //           });
              
    //         }).catch(err => {
    //             console.log('Failed to copy text: ', err);
    //         });
    //     });
    // });

  function calculateSavePrice(originalPrice, discountPercentage) {
      const proPrice = originalPrice / 100;
      const discountAmount = (proPrice * discountPercentage) / 100;
      const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : window.themeVariables.settings.moneyFormat;
      const formattedDiscount = Math.round(discountAmount);
      let formattedString = currencyFormat.replace(/\{\{\s*amount\s*\}\}/, formattedDiscount);
      
      // Remove all HTML tags from the formatted string (i.e., <span> tags)
      formattedString = formattedString.replace(/<\/?[^>]+(>|$)/g, "");
      return formattedString;
  }

  function calculateOfferPrice(originalPrice, discountPercentage) {
      const proPrice = originalPrice / 100;
      const discountAmount = (proPrice * discountPercentage) / 100;
      const offerPrice = proPrice - discountAmount;
      const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : window.themeVariables.settings.moneyFormat;
      let formattedString = currencyFormat.replace(/\{\{\s*amount\s*\}\}/, Math.round(offerPrice));
    
      // Remove all HTML tags from the formatted string (i.e., <span> tags)
      formattedString = formattedString.replace(/<\/?[^>]+(>|$)/g, "");
      return formattedString;
  }
  
   document.addEventListener('variant:change', (e) => {
     
     //Add to Cart Below Coupon Start
     let offerBoxes = document.querySelectorAll('.offer__slidezs_container .offer');
     let variants = e.detail.variant;
     offerBoxes.forEach((offerBox) => {
        let discountPercentage = offerBox.querySelector('.offers-section')?.getAttribute('data-discount');
        if(discountPercentage){
          let offerPriceWrapper = offerBox.querySelector('.offer-description span');
            offerPriceWrapper.textContent = calculateSavePrice(variants["price"], Number(discountPercentage));
            // console.log(discountPercentage, "discountPercentage")
            // console.log(calculateSavePrice(variants["price"], Number(discountPercentage)), "Offer price");  
        }
     })
     //Add to Cart Below Coupon End
     
    //Best Price Offer Start
     let dedicatedProductOffer = document.querySelector('.offer__box_bar_container');
     if(dedicatedProductOffer){
       let discountPrice = dedicatedProductOffer?.getAttribute('data-discount');
       let priceWrapper = dedicatedProductOffer?.querySelector('.offer__first_text span');
       if(discountPrice && priceWrapper){
         priceWrapper.textContent = calculateOfferPrice(variants["price"], Number(discountPrice));
         console.log( calculateOfferPrice(variants["price"], Number(discountPrice)))
       }
     }
    //Best Price Offer End
   })

  
});

// Discount JS
// $(document).ready(function(){
// let GetPrice = $('.product-info .product-info__price sale-price .money').text();
//   let discountValues = [];
//   $('.offer__box_bar_container').each(function() {
//     if($(this).attr('data-discount') != undefined){
//       discountValues.push($(this).attr('data-discount'));
//     }
//   });

//   Discountcalculate(GetPrice,discountValues);

//     function Discountcalculate(G_Price,discountArr) {
//     $.each(discountArr, function( index, discount ) {
//       let removeSpace = G_Price.replace(/\s+/g, ' ').trim();
//       let removeText = removeSpace.replace(/ \/ per/g, '');
//       // let updatedPrice = removeSpace.replace(/Rs\. | \/ per/g, '');
//       let updatedPrice = removeText.replace(/Rs\. |,/g, '');
   
//       let discountedPrice = Math.round(Number(updatedPrice)) * (Number(discount) / 100);
//       let finalPrice = Math.round(Number(updatedPrice)) - discountedPrice;
      
//       // console.log(finalPrice,'finalPrice')
//       let formattedDiscountedPrice = "Rs.&nbsp;" + Math.round(finalPrice);
//       $(`.offer__box_custom .offer__box_top .offer__box_bar .offer__box_bar_container[data-discount='${discount}'] .offer__first_text span`).each(function() {
//         $(this).html(formattedDiscountedPrice);
//       });

      
//       let finalPriceAdditionalOffer = discountedPrice;
//       let AdditionalOfferformattedDiscountedPrice = "Rs.&nbsp;" + Math.round(finalPriceAdditionalOffer);
//       $(`.offer__box_custom .offer__box_top .offer__box_bar .offer__box_bar_container[data-discount='${discount}'] .offer__first_text span`).each(function() {
//         $(this).html(AdditionalOfferformattedDiscountedPrice);
//       });
//     });
//   } 
  
// });
// Offer Discount Slide Js End


document.addEventListener('DOMContentLoaded', () => {
  let hamburger_menu = document.querySelector('.header__icon-list .hamburger-icon-wrapper.desktop');
  let custom_mega_menu = document.querySelector('.header .custom-megamenu-container');

  // Toggle the menu on hamburger click
  hamburger_menu?.addEventListener('click', (event) => {
    event.stopPropagation(); // Prevent the event from triggering the document listener
    let classContains = custom_mega_menu?.classList.contains('is_open');
    let sln = document.querySelectorAll('.custom-megamenu_nav .sl_nested_nav');
    let tln = document.querySelectorAll('.custom-megamenu_nav .tln_nested_nav');
    
    if (classContains) {
      custom_mega_menu.classList.remove('megamenu_unfold');
      hamburger_menu.classList.remove('active');
      custom_mega_menu.classList.remove('is_open');
      custom_mega_menu.classList.add('is_closed');
      custom_mega_menu.removeAttribute('open', 'open');
    } else {
      custom_mega_menu.classList.add('megamenu_unfold');
      custom_mega_menu.classList.add('is_open');
      custom_mega_menu.classList.remove('is_closed');
      hamburger_menu.classList.add('active');
      custom_mega_menu.setAttribute('open', 'open');
      
      // Click on the first element of sl_nested_nav
      if (sln.length > 0) {
        sln[0]?.querySelector('.arrow-icon-wrapper').click();
      }
      
      // Click on the first element of tln_nested_nav
      if (tln.length > 0) {
        tln[0]?.querySelector('.arrow-icon-wrapper').click();
      }
    }
  });
  
  // Close the menu if clicking outside
  document.addEventListener('click', (event) => {
    // Check if the click occurred outside of the custom_mega_menu or hamburger_menu
    if (!custom_mega_menu.contains(event.target) && !hamburger_menu.contains(event.target)) {
      if (custom_mega_menu.classList.contains('is_open')) {
        custom_mega_menu.classList.remove('megamenu_unfold');
        hamburger_menu.classList.remove('active');
        custom_mega_menu.classList.remove('is_open');
        custom_mega_menu.classList.add('is_closed');
        custom_mega_menu.removeAttribute('open', 'open');
      }
    }
  });

// data-nav-link
  let nestedNav = document.querySelectorAll('.megamenu_container .contain_nested_nav');
  nestedNav.forEach((nav) => {
    const secondLevelNav = nav.querySelector('.megamenu_nav_second_level');
    const thirdLevelNav = nav.querySelector('.megamenu_nav_third_level');
    const nav_img_blk = document.querySelectorAll('.nav_features_wrapper .mega-menu-text-image');
  
    // First level click handler
    nav.querySelector('.first_level_links .arrow-icon-wrapper')?.addEventListener('click', (e) => {
      e.preventDefault();
     nestedNav.forEach((n) => {
      n.querySelector('.megamenu_nav_second_level')?.classList.remove('open_nav');
      n.querySelector('.megamenu_nav_third_level')?.classList.remove('open_nav');
      n?.classList.remove('active');
      n.querySelector('.tln_nested_nav')?.classList.remove('active');
    });
      secondLevelNav?.classList.add('open_nav');
      nav.classList.add('active');
      nav_img_blk.forEach(img_blk => img_blk.classList.add('hide-block'));
      let img_blk_id = nav?.dataset.navLink;
      document.querySelector(`.custom-megamenu-wrapper #${img_blk_id}`)?.classList.remove('hide-block');
    });
  
    // Second level click handler
    nav.querySelector('.second_level_links .arrow-icon-wrapper')?.addEventListener('click', (e) => {
      e.preventDefault();
      nestedNav.forEach((n) => {
        n.querySelector('.megamenu_nav_third_level')?.classList.remove('open_nav');
        n.querySelectorAll('.tln_nested_nav').forEach(tln => tln?.classList.remove('active'));
        // console.log("N", n.querySelector('.tln_nested_nav'))
      });
      thirdLevelNav?.classList.add('open_nav');
      nav.classList.add('active');
    });
  });


  
  const megaMenus = document.querySelectorAll('details[is="mega-menu-disclosure"]');
  megaMenus.forEach((megaMenu) => {
    const secondLevelLinks = megaMenu.querySelectorAll(".second_level_links");
    const thirdLevelNavs = megaMenu.querySelectorAll(".third_level_nav");

    // Function to hide all third level menus and remove active class from second level links
    function hideAllThirdLevelNavs() {
      thirdLevelNavs.forEach((nav) => {
        nav.classList.remove("active");
      });
      secondLevelLinks.forEach((link) => {
        link.classList.remove("active");
      });
    }

    // Function to show the corresponding third level menu and add active class to the second level link
    function showThirdLevelNav(targetId) {
      const targetNav = megaMenu.querySelector(`#${targetId}`);
      if (targetNav) {
        targetNav.classList.add("active");
      }
    }

    // Add hover event listeners to second level links
    secondLevelLinks.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        const targetId = link.getAttribute("data-target");
        if (targetId) {
          hideAllThirdLevelNavs();
          showThirdLevelNav(targetId);
          link.classList.add("active"); // Add active class to the hovered second level link
        }
      });
    });

    // Activate the first third level menu and its corresponding second level link by default
    const firstLink = secondLevelLinks[0];
    if (firstLink) {
      const targetId = firstLink.getAttribute("data-target");
      hideAllThirdLevelNavs(); // Ensure all menus are hidden first
      showThirdLevelNav(targetId);
      firstLink.classList.add("active"); // Add active class to the first second level link
    }
  }); 



// Impact callout Start
const counters = document.querySelectorAll('.impact_callout .impact_content_wrap .counter');
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            startCounter(entry.target);
            observer.unobserve(entry.target);
        }
    });
}, { threshold: 0.5 });

// Initialize counters
counters.forEach(counter => {
    const start = +counter.getAttribute('data-start');
    const suffix = counter.getAttribute('data-suffix');
    const valueEl = counter.querySelector('.counter-value');
    const suffixEl = counter.querySelector('.counter-suffix');
    
    // Set initial display
    const formatted = formatCounterValue(start, suffix);
    valueEl.textContent = formatted.value;
    suffixEl.textContent = formatted.suffix;
    
    observer.observe(counter);
});

function startCounter(element) {
    const start = +element.getAttribute('data-start');
    const target = +element.getAttribute('data-target');
    const suffix = element.getAttribute('data-suffix');
    const valueEl = element.querySelector('.counter-value');
    const suffixEl = element.querySelector('.counter-suffix');
    const duration = 7000;
    const startTime = performance.now();
    
    function updateCounter(currentTime) {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const easeProgress = 1 - Math.pow(1 - progress, 3);
        const currentValue = Math.floor(start + (easeProgress * (target - start)));
        
        const formatted = formatCounterValue(currentValue, suffix);
        valueEl.textContent = formatted.value;
        suffixEl.textContent = formatted.suffix;
        
        if (progress < 1) {
            requestAnimationFrame(updateCounter);
        }
    }
    requestAnimationFrame(updateCounter);
}

function formatCounterValue(value, suffix) {
  value = Math.max(0, value); // Ensure non-negative
  switch(suffix) {
      case 'L+':
          return {
              value: (value / 1).toFixed(0),
              suffix: 'L+'
          };
      
      case 'M+':
          return {
              value: value.toFixed(0),
              suffix: 'M+'
          };
      
      case '%':
          return {
              value: Math.min(value, 100).toFixed(0),
              suffix: '%'
          };
      
      default:
          return {
              value: value.toFixed(0),
              suffix: suffix
          };
  }
}

// Impact callout Animation Start
function startMarquee(element) {
  // Ensure we are working with a valid DOM element
  if (!(element instanceof HTMLElement)) {
      console.error("Invalid element passed to startMarquee");
      return;
  }

  // Get the desktop and mobile textPath and path inside the element
  const textPathDesktop = element.querySelector('textPath#impact-marquee');
  const pathDesktop = element.querySelector('path#impactPath');
  const textPathMobile = element.querySelector('textPath#mob-impact-marquee');
  const pathMobile = element.querySelector('path#mob-impactPath');
  
  // Get marquee text and speed from the data attributes
  const marqueeText = element.dataset.marqueeText || "Default Text ";
  const desktopSpeed = parseFloat(element.dataset.desktopSpeed) || 2;
  const mobileSpeed = parseFloat(element.dataset.mobileSpeed) || 1;
  
  // Check if repeating the content is enabled (default is true)
  const shouldRepeat = element.dataset.repeat !== "false";
  
  // Select appropriate path, textPath, and speed based on viewport size
  const isMobile = window.matchMedia("(max-width: 699px)").matches;
  const textPath = isMobile ? textPathMobile : textPathDesktop;
  const path = isMobile ? pathMobile : pathDesktop;
  const speed = isMobile ? mobileSpeed : desktopSpeed;

  // Exit if no path or textPath is found
  if (!textPath || !path) {
      console.error("SVG path or textPath not found!");
      return;
  }

  // Get the total length of the path and prepare the repeated text dynamically
  const pathLength = path.getTotalLength();
  
  // Create a temporary element to measure content width
  const tempElement = document.createElement('span');
  tempElement.innerHTML = `<a style="text-decoration: none;">${marqueeText}</a>`;
  document.body.appendChild(tempElement);
  const contentWidth = tempElement.offsetWidth;
  document.body.removeChild(tempElement);

  // Determine the content to display based on the repeat option
  let repeatedText;
  if (shouldRepeat) {
    const repetitionCount = isMobile ? Math.ceil(pathLength / contentWidth) + 18 : Math.ceil(pathLength / contentWidth) + 10;
    repeatedText = `<a style="text-decoration: none;">${marqueeText}</a>`.repeat(repetitionCount);
  } else {
    repeatedText = `<a style="text-decoration: none;">${marqueeText}</a>`;
  }
  
  textPath.innerHTML = repeatedText;

  let offset = 0;
  let animationFrame;

  // Animation function
  function animateText() {
      offset -= speed;
      if (offset < -pathLength) {
          offset = 0;
      }
      // offset += speed;  // Change this to increment for clockwise scrolling
      // if (offset > pathLength) {
      //   offset = 0;
      // }
      textPath.setAttribute('startOffset', `${offset}px`);
      animationFrame = requestAnimationFrame(animateText);
  }

  // Intersection observer to start/stop animation based on visibility
  function handleIntersection(entries) {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              animateText();
          } else {
              cancelAnimationFrame(animationFrame);
          }
      });
  }

  // Set up intersection observer to detect when the element is in the viewport
  const observer = new IntersectionObserver(handleIntersection, { threshold: 0.1 });
  observer.observe(element);
}

document.querySelectorAll('.impact_callout .wavy_wrapper').forEach(element => {
  if (element instanceof HTMLElement) {
      startMarquee(element);
  } else {
      console.error('Element is not a valid HTML element:', element);
  }
});
// Impact callout Animation End
// Impact callout End

// View Mode Toggle
function viewModeToggle() {
  const coll_view_modes = document.querySelectorAll('.view_mode_wrapper .view_modes');
  const coll_section = document.querySelector('.shopify-section--main-collection');

  // Restore the view mode from session storage
  const savedMode = sessionStorage.getItem('view_mode');
  if (savedMode && coll_section) {
    coll_section.classList.remove('two_column_grid', 'three_column_grid', 'four_column_grid');
    coll_section.classList.add(savedMode);

    // Set active class to the corresponding button
    coll_view_modes.forEach((btn) => {
      btn.classList.remove('active');
      if (
        (savedMode === 'two_column_grid' && btn.hasAttribute('two-col-mode')) ||
        (savedMode === 'three_column_grid' && btn.hasAttribute('three-col-mode')) ||
        (savedMode === 'four_column_grid' && btn.hasAttribute('four-col-mode'))
      ) {
        btn.classList.add('active');
      }
    });

    // Optional: update the CSS variable
    const cols = {
      two_column_grid: '2',
      three_column_grid: '3',
      four_column_grid: '4',
    };
    coll_section.style.setProperty('--product-list-items-per-row', cols[savedMode], 'important');
  }

  // Set event listeners
  coll_view_modes.forEach((viewMode) => {
    viewMode.addEventListener('click', (e) => {
      coll_view_modes.forEach((btn) => btn.classList.remove('active'));

      const currentElement = e.target.closest('.view_modes');
      if (!currentElement) return;

      let mode = '';
      if (currentElement.hasAttribute('two-col-mode')) {
        mode = 'two_column_grid';
        coll_section?.style.setProperty('--product-list-items-per-row', '2', 'important');
      }
      if (currentElement.hasAttribute('three-col-mode')) {
        mode = 'three_column_grid';
        coll_section?.style.setProperty('--product-list-items-per-row', '3', 'important');
      }
      if (currentElement.hasAttribute('four-col-mode')) {
        mode = 'four_column_grid';
        coll_section?.style.setProperty('--product-list-items-per-row', '4', 'important');
      }

      if (mode) {
        currentElement.classList.add('active');
        coll_section?.classList.remove('two_column_grid', 'three_column_grid', 'four_column_grid');
        coll_section?.classList.add(mode);
        sessionStorage.setItem('view_mode', mode); // Save selected mode
      }
    });
  });
}

viewModeToggle();
document.addEventListener('custom:filter-tab', viewModeToggle);
  
});

$(document).ready(function() {
  const mediaQuery = window.matchMedia('(max-width: 699px)');
  $('.footer_link_title').on('click', function() {
    if (mediaQuery.matches) { // If the media query matches (screen is 699px or less)
      $('.collaps_wrapper').not($(this).siblings('.collaps_wrapper')).slideUp();
      $('.footer_link_title').not($(this)).removeClass('active');
      $(this).toggleClass('active');
      $(this).siblings('.collaps_wrapper').slideToggle();
    }
  });
  
  // On clicking the 'More/Less' link
  $('.toggle-more-less').on('click', function(e) {
    e.preventDefault();
    
    // Find the parent UL and toggle hidden links
    var $this = $(this);
    var $ul = $this.closest('ul');
    var hiddenLinks = $ul.find('.footer_nav_link.hide');

    if (hiddenLinks.is(':visible')) {
      // If links are visible, hide them and update the link to show "More"
      hiddenLinks.hide();
      var remainingCount = hiddenLinks.length;
      $this.html(`+ <span>${remainingCount} more</span>`);
    } else {
      // If links are hidden, show them and change the link to "Less"
      hiddenLinks.show();
      $this.html(`<span>less</span>`);
    }
  });
  
});

// $(document).ready(function() {
//   $(".categories-name .categories-menus").click(function(e) {
//     e.preventDefault();
//     if($(this).hasClass('active')) return;
//     // Remove active class from all menu items
//     $('.categories-name .categories-menus').removeClass('active');
    
//     // Add active class to the clicked menu item
//     $(this).addClass('active');

//     var currentProduct = $(this).attr('collection-id');
//     var selectProduct = '[select-id="' + currentProduct + '"]';

//     // Hide animation for the current active product list wrapper
//     $(".product_list_wrappper.active").css({
//       'transform': 'translateY(15px)',
//       'opacity': '0',
//       'transition': 'transform 0.8s ease, opacity 0.8s ease'
//     }).delay(400).queue(function(next) {
//       // After animation finishes, remove the active class
//       $(this).removeClass('active');
//       next();
//     });

//     // Prepare to show the selected product (wait for the hide animation to complete)
//     setTimeout(function() {
//       // Set the initial state for the selected product (off-screen, hidden)
//       $(selectProduct).css({
//         'transform': 'translateY(15px)',  // Start below
//         'opacity': '0',
//       }).addClass('active');

//       // Trigger the show animation (move to normal position, fade in)
//       setTimeout(function() {
//         $(selectProduct).css({
//           'transform': 'translateY(0)', // Move to the final position
//           'opacity': '1',
//           'transition': 'transform 0.6s ease, opacity 0.6s ease' // Smooth transition
//         });
//       }, 50); // Small delay to ensure transition is applied
//     }, 400); // Delay the show until the hide animation completes
//   });
// });


document.addEventListener('DOMContentLoaded', () => {
window.initLazyScript = function (element, callback, threshold = 500) {
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof callback === 'function') {
            callback();
            observer.unobserve(entry.target);
          }
        }
      });
    }, { rootMargin: `0px 0px ${threshold}px 0px` });

    io.observe(element);
  } else {
    callback();
  }
}
  
if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endDate = new Date(this.dataset.endDate).getTime();
      console.log(this.dataset.endDate, "this.this.dataset.endDate")
      if (!Number(this.endDate)) return;
     
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    timer() {
      const timeDiff = this.endDate - new Date();

      if (timeDiff < 0) {
        clearInterval(this.interval);
        return;
      }

      const hours = Math.floor(timeDiff / this.hour);
      const mins = Math.floor(timeDiff / this.minute);
      const secs = Math.floor(timeDiff / this.second);

      this.hoursEl.textContent = hours;
      this.minsEl.textContent = mins - hours * 60;
      this.secsEl.textContent = secs - mins * 60;
    }

    timer() {
      const timeDiff = this.endDate - new Date();
    
      if (timeDiff < 0) {
        clearInterval(this.interval);
        return;
      }
    
      const hours = Math.floor(timeDiff / this.hour);
      const mins = Math.floor(timeDiff / this.minute);
      const secs = Math.floor(timeDiff / this.second);
    
      // 👇 Pad all values with leading zeros if needed
      this.hoursEl.textContent = hours.toString().padStart(2, '0');
      this.minsEl.textContent = (mins - hours * 60).toString().padStart(2, '0');
      this.secsEl.textContent = (secs - mins * 60).toString().padStart(2, '0');
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
})
  



//collection page mobile sort filter
// document.addEventListener("DOMContentLoaded", () => {
//   const productGridSelector = ".collection";
//   if (!document.querySelector(productGridSelector)) return;

//   document.addEventListener("click", (e) => {
//     const sortWrapper = e.target.closest(".sort_by_mob");
//     const mobSortBtn = e.target.closest(".mob-sort-btn");
//     const mobSortDropdown = sortWrapper ? sortWrapper.querySelector(".mob-sort-dropdown") : null;
//     const sortCurrent = sortWrapper ? sortWrapper.querySelector(".sort-current") : null;
//     if (!mobSortDropdown) return;

//     const ul = mobSortDropdown.querySelector("ul");
//     const overlay = mobSortDropdown.querySelector(".overlay");

//     const closeDropdown = () => {
//       // Remove animate to trigger slide-down
//       ul.classList.remove("animate");

//       // Wait for CSS transition end to remove show
//       const removeShow = () => {
//         mobSortDropdown.classList.remove("show");
//         ul.removeEventListener("transitionend", removeShow);
//       };

//       ul.addEventListener("transitionend", removeShow);
//     };

//     // Toggle dropdown
//     if (mobSortBtn) {
//       if (!mobSortDropdown.classList.contains("show")) {
//         mobSortDropdown.classList.add("show");
//         // Delay adding animate for smooth slide-up
//         setTimeout(() => ul.classList.add("animate"), 50);
//       } else {
//         closeDropdown();
//       }
//       return;
//     }

//     // Close via close button
//     if (e.target.closest(".mob-sort-close")) {
//       closeDropdown();
//       return;
//     }

//     // Close via overlay click
//     if (e.target === overlay) {
//       closeDropdown();
//       return;
//     }

//     // Sort option click
//     const sortOption = e.target.closest(".mob-sort-option");
//     if (sortOption && sortCurrent) {
//       const value = sortOption.getAttribute("data-value");
//       sortCurrent.textContent = sortOption.textContent;

//       closeDropdown(); // smooth close

//       const url = new URL(window.location.href);
//       url.searchParams.set("sort_by", value);
//       history.pushState({}, "", url.toString());

//       fetch(`${window.location.pathname}?sort_by=${value}`)
//         .then(res => res.text())
//         .then(html => {
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(html, "text/html");
//           const newGrid = doc.querySelector(productGridSelector);
//           if (newGrid) document.querySelector(productGridSelector).innerHTML = newGrid.innerHTML;
//         })
//         .catch(err => console.error("Sorting failed:", err));
//       return;
//     }

//     // Click outside closes dropdown
//     if (!e.target.closest(".sort_by_mob")) {
//       document.querySelectorAll(".mob-sort-dropdown").forEach(drop => {
//         const innerUl = drop.querySelector("ul");
//         innerUl.classList.remove("animate");
//         const removeShow = () => {
//           drop.classList.remove("show");
//           innerUl.removeEventListener("transitionend", removeShow);
//         };
//         innerUl.addEventListener("transitionend", removeShow);
//       });
//     }
//   });

//   // Browser navigation
//   window.addEventListener("popstate", () => {
//     const params = new URLSearchParams(window.location.search);
//     const sortBy = params.get("sort_by") || "";
//     if (sortBy) {
//       fetch(`${window.location.pathname}?sort_by=${sortBy}`)
//         .then(res => res.text())
//         .then(html => {
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(html, "text/html");
//           const productGrid = doc.querySelector(productGridSelector);
//           if (productGrid) document.querySelector(productGridSelector).innerHTML = newGrid.innerHTML;
//         });
//     }
//   });
// });


//collection page mobile sort filter
document.addEventListener("DOMContentLoaded", () => {
  const productGridSelector = ".collection";
  if (!document.querySelector(productGridSelector)) return;

  document.addEventListener("click", (e) => {
    const sortWrapper = e.target.closest(".sort_by_mob");
    const mobSortBtn = e.target.closest(".mob-sort-btn");
    const mobSortDropdown = sortWrapper ? sortWrapper.querySelector(".mob-sort-dropdown") : null;
    const sortCurrent = sortWrapper ? sortWrapper.querySelector(".sort-current") : null;
    if (!mobSortDropdown) return;

    const ul = mobSortDropdown.querySelector("ul");
    const overlay = mobSortDropdown.querySelector(".overlay");

    const closeDropdown = () => {
      ul.classList.remove("animate");
      const removeShow = () => {
        mobSortDropdown.classList.remove("show");
        ul.removeEventListener("transitionend", removeShow);
      };
      ul.addEventListener("transitionend", removeShow);
    };

    // 👉 Toggle dropdown
    if (mobSortBtn) {
      if (!mobSortDropdown.classList.contains("show")) {
        mobSortDropdown.classList.add("show");
        setTimeout(() => ul.classList.add("animate"), 50);
      } else {
        closeDropdown();
      }
      return;
    }

    // 👉 Close via close button
    if (e.target.closest(".mob-sort-close")) {
      closeDropdown();
      return;
    }

    // 👉 Close via overlay click
    if (e.target === overlay) {
      closeDropdown();
      return;
    }

    // 👉 Sort option click
    const sortOption = e.target.closest(".mob-sort-option");
    if (sortOption && sortCurrent) {
      const value = sortOption.getAttribute("data-value");
      sortCurrent.textContent = sortOption.textContent;

      // ✅ Add "active" class to first .image-link-blocks__item button
      const allFilterButtons = document.querySelectorAll(".image-link-blocks__item button");
      allFilterButtons.forEach(btn => btn.classList.remove("active"));
      const firstFilterButton = document.querySelector(".image-link-blocks__item:first-child button");
      if (firstFilterButton) firstFilterButton.classList.add("active");

      // Smooth close popup
      closeDropdown();

      // Update URL without reload
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", value);
      history.pushState({}, "", url.toString());

      // AJAX sorting
      fetch(`${window.location.pathname}?sort_by=${value}`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newGrid = doc.querySelector(productGridSelector);
          if (newGrid) {
            document.querySelector(productGridSelector).innerHTML = newGrid.innerHTML;
          }
        })
        .catch(err => console.error("Sorting failed:", err));
      return;
    }

    // 👉 Click outside closes dropdown
    if (!e.target.closest(".sort_by_mob")) {
      document.querySelectorAll(".mob-sort-dropdown").forEach(drop => {
        const innerUl = drop.querySelector("ul");
        innerUl.classList.remove("animate");
        const removeShow = () => {
          drop.classList.remove("show");
          innerUl.removeEventListener("transitionend", removeShow);
        };
        innerUl.addEventListener("transitionend", removeShow);
      });
    }
  });

  // 👉 Browser navigation
  window.addEventListener("popstate", () => {
    const params = new URLSearchParams(window.location.search);
    const sortBy = params.get("sort_by") || "";
    if (sortBy) {
      fetch(`${window.location.pathname}?sort_by=${sortBy}`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const productGrid = doc.querySelector(productGridSelector);
          if (productGrid) document.querySelector(productGridSelector).innerHTML = productGrid.innerHTML;
        });
    }
  });
});




document.addEventListener("DOMContentLoaded", () => {
  const applyDarkModeToShadow = () => {
    const html = document.querySelector("html");
    const isDark = html.getAttribute("data-theme") === "dark";

    const container = document.querySelector("shadow-dom-container");
    if (!container || !container.shadowRoot) return;

    // Remove previous styles (if re-run)
    const old = container.shadowRoot.querySelector("#dark-mode-shadow-style");
    if (old) old.remove();

    if (isDark) {
      const style = document.createElement("style");
      style.id = "dark-mode-shadow-style";
      style.textContent = `
        img {
          background: #000 !important;
          filter: invert(1) hue-rotate(180deg) !important;
        }
      `;
      container.shadowRoot.appendChild(style);
    }
  };

  // Run once on load
  applyDarkModeToShadow();

  // If theme changes dynamically
  const observer = new MutationObserver(applyDarkModeToShadow);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
});


document.addEventListener('DOMContentLoaded', () => {
  // function handleVariantChange(){
  //   let checked_option_elements = document.querySelectorAll('fieldset.size_option_field label');
  //   if (!checked_option_elements.length) return;
  //   if(checked_option_elements.length > 0){
  //       checked_option_elements.forEach((sizeInput) => {
  //       sizeInput.addEventListener('click', (event) => {
  //         let optionsParentEle = event.target.closest('variant-picker');
  //         if(optionsParentEle){
  //           optionsParentEle.classList.remove('handle_variant_change');
  //         }
  //       })
  //     })
  //   }
  // }

  function handleVariantChange() {
    const allLabels = document.querySelectorAll('variant-picker fieldset label');
    if (!allLabels.length) return;

    allLabels.forEach((label) => {
      label.addEventListener('click', (event) => {
        const clickedFieldset = event.target.closest('fieldset');
        const variantPicker = event.target.closest('variant-picker');
        if (!clickedFieldset || !variantPicker) return;

        const clickedOption = clickedFieldset.getAttribute('data-option');
        const allFieldsets = variantPicker.querySelectorAll('fieldset');

        allFieldsets.forEach((fieldset) => {
          const optionType = fieldset.getAttribute('data-option');

          if (clickedOption === 'color') {
            // remove from all except color
            if (optionType !== 'color') {
              fieldset.classList.remove('handle_variant_change');
            }
          } else {
            // remove from all
            fieldset.classList.remove('handle_variant_change');
          }
        });
      });
    });
  }

  handleVariantChange();
  document.addEventListener("custom:quick-buy", handleVariantChange)
});


document.addEventListener('DOMContentLoaded', () => {
    const offerSliders = document.querySelectorAll('.product-info__offer-list');
    offerSliders.forEach((slider) => {
      const nextButton = slider.querySelector('.swiper-button-next');
      const prevButton = slider.querySelector('.swiper-button-prev');
      const totalSlides = slider.querySelectorAll('.swiper-slide').length;

      const swiper = new Swiper(slider, {
        slidesPerView: 1.5,
        spaceBetween: 10,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          400: {
            slidesPerView: 2.2,
          },
          768: {
            slidesPerView: 3,
          },
        },
        on: {
          init() {
            toggleArrows(this);
          },
          resize() {
            toggleArrows(this);
          },
        },
      });

      function toggleArrows(swiperInstance) {
        const slidesPerView =
          typeof swiperInstance.params.slidesPerView === 'number'
            ? swiperInstance.params.slidesPerView
            : swiperInstance.slidesPerViewDynamic();

        if (totalSlides <= slidesPerView) {
          nextButton.style.display = 'none';
          prevButton.style.display = 'none';
        } else {
          nextButton.style.display = '';
          prevButton.style.display = '';
        }
      }
    });
});


//Header Position (apply top sticky announcement & header)
$(document).ready(function() {
  function updateStickySpacing() {
    let announc = document.querySelector('.shopify-section--announcement-bar');
    let header = document.querySelector('.shopify-section--header');

    if (!announc || !header) return;

    let announcPosition = window.getComputedStyle(announc).position;
    let headerPosition = window.getComputedStyle(header).position;

    // Only if BOTH are sticky
    if ((announcPosition === 'fixed' || announcPosition === 'sticky') &&
        (headerPosition === 'fixed' || headerPosition === 'sticky')) {

      announc.style.top = '0px';
      header.style.top = announc.offsetHeight + 'px';

    } else {
      // ❌ reset
      header.style.top = '';
    }
  }

  // Run on scroll
  $(window).on('scroll', updateStickySpacing);

  // ✅ Run on resize
  $(window).on('resize', function() {
    updateStickySpacing();
  });

  // Initial trigger
  updateStickySpacing();
});


document.addEventListener('click', function (e) {
  const gtbButton = e.target.closest(
    'quick-buy-drawer .custom-gtb-button.go-to-bag, .quick-buy-drawer .quick-buy-drawer__info form .button[href="/cart"]'
  );

  if (gtbButton) {
    // Stop default link/button behavior
    e.preventDefault();
    e.stopPropagation();

    const headerCartIcon = document.querySelector('header #header-cart-icon');

    if (headerCartIcon) {
      headerCartIcon.click();
    }
  }
});